/**
 * Seatics' header "Ticket Packages" chip (#sea-marketing-header) is absolutely positioned at
 * `right: 453px`, which assumes their 428px guarantee column. Ours is 628px wide, so the chip
 * landed on the guarantee copy. Re-anchor it as a one-line pill in the empty top-right corner
 * of the event header instead.
 *
 * Constraints:
 * - CSS only. Moving the node into the layout pushed the map list below #tn-maps (Seatics sizes
 *   the list from #event-info-area alone), and anything placed inside .event-info-right-col is
 *   wiped by the desktop disclaimer rewrite.
 * - Never set `display`: Seatics shows the chip (>= 992px, only when the event has package
 *   inventory) and hides it on close.
 * - Below 992px Seatics hides the chip with `display: none !important`, so mobile web and the
 *   native app are untouched.
 */
export const TICKET_PACKAGES_PROMO_CSS = `
@media (min-width: 992px) {
  #tn-maps #sea-marketing-header {
    top: 21px;
    right: 27px;
    left: auto;
    bottom: auto;
    width: auto;
    white-space: nowrap;
    padding: 3px 24px 3px 8px;
    line-height: 18px;
    opacity: 1;
    z-index: 2;
  }

  #tn-maps #sea-marketing-header .sea-marketing-header-gift,
  #tn-maps #sea-marketing-header .sea-marketing-header-label,
  #tn-maps #sea-marketing-header .sea-marketing-header-label-show {
    display: inline-block;
    vertical-align: middle;
    line-height: 18px;
  }

  #tn-maps #sea-marketing-header .sea-marketing-header-label-show {
    margin-left: 4px;
  }

  #tn-maps #sea-marketing-header .sea-marketing-header-close {
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
  }
}
`;
